ACC.productFavorites = {
    bind: function () {
        $(document).on('click', '.js-icon-favorite-inactive', this.showNoDimensionsMessage.bind(this));
        $(document).on('click', '.js-icon-favorite-active', this.addToFavoriteList.bind(this));
        $(document).on('click', '.js-icon-favorite-remove', this.removeFromFavoriteList.bind(this));
        $(document).on('click', '.js-undo-remove', this.undoDelete.bind(this));
        $(document).on('click', '.js-favorite-list-add-to-cart-form .js-add-to-cart', this.validateAddToCartButtonClickOnFavoriteList.bind(this));
        $(document).on('input', '.js-favorite-list-qty', this.showPricesOnQuantityChangeFromFavoriteList.bind(this));
        $(document).on('change', '.js-favorite-list-qty-unit', this.showPricesOnQuantityChangeFromFavoriteList.bind(this));
    },
    context: '', // Can be 'pdp' (product details page), 'plp' (product listing page), 'flp' (favourite listing page)
    constants: {
        DISABLED_ELEMENT_OPACITY: .8,
    },
    priceRequestRetryTimeoutMap: new Map(),
    updateFavoritesOnPdp: function (isFavorite, variantCode) {
        var favContainer = $('.js-toggle-favorites-container');
        favContainer.removeClass(['js-favorite-added-state', 'js-favorite-removed-state'])

        $(favContainer).data('product-code', variantCode);

        if (variantCode) {
            $('.js-no-dimensions').addClass('hide');
        }
        if (!KMVP.status.isLoggedIn) {
            return favContainer.addClass('js-favorite-disabled-state');
        }
        if (variantCode && isFavorite) {
            favContainer.addClass('js-favorite-added-state');
        }
    },
    addToFavoriteList: function (event) {
        if (!KMVP.status.isLoggedIn) {
            return;
        }

        var toggleElement = event.target.closest('.js-toggle-favorites-container');

        if ($(toggleElement).data('action-blocked') === true) {
            return;
        }

        var variantCode = $(toggleElement).data('product-code');

        if (ACC.productFavorites.context == 'pdp' && !variantCode) {
            return $('.js-no-dimensions').removeClass('hide');
        }

        $(toggleElement).data('action-blocked', true);

        $.ajax({
            url: ACC.favoritelistUrl + "/" + variantCode,
            type: "POST",
            success: function () {
                $(toggleElement).addClass('js-favorite-added-state');
                ACC.productFavorites.handleHeaderNotification();
            },
            error: function () {
                alert("Failed to process the favorite");
            },
            complete: function () {
                $(toggleElement).data('action-blocked', false);
            }
        });
    },
    removeFromFavoriteList: function (event) {
        var toggleElement = event.target.closest('.js-toggle-favorites-container');

        if ($(toggleElement).data('action-blocked') === true) {
            return;
        }

        toggleElement.classList.remove('js-favorite-added-state')
        toggleElement.classList.add('js-favorite-removed-state');
        if (ACC.productFavorites.context == 'flp') {
            toggleElement.closest('.product-variant').classList.add('product-variant-disabled');
        }
        var variantCode = $(toggleElement).data('product-code');

        var deleteFunction = function () {
            $(toggleElement).data('action-blocked', true);

            $.ajax({
                url: ACC.favoritelistUrl + "/" + variantCode,
                type: "DELETE",
                success: function () {
                    if (ACC.productFavorites.context == 'flp') {
                        ACC.productFavorites.adjustFavoritePageTemplate(toggleElement);
                    } else {
                        toggleElement.classList.remove('js-favorite-removed-state');
                    }
                },
                error: function () {
                    alert("Failed to process the favorite");
                    if (ACC.productFavorites.context == 'flp') {
                        toggleElement.closest('.product-variant').classList.remove('product-variant-disabled');
                    }
                },
                complete: function () {
                    $(toggleElement).data('action-blocked', false);
                }
            });
            // within the timeout the user
            // can "undo" the delete action
        };

        if ($(toggleElement).data('instant-remove') === true) {
            deleteFunction();
        } else {
            var deleteTimeout;
            deleteTimeout = setTimeout(deleteFunction, 3000);
            this.deleteTimeout = deleteTimeout;
        }
    },
    undoDelete: function (event) {
        var deleteTimeout = this.deleteTimeout;
        clearTimeout(deleteTimeout);
        var toggleElement = event.target.closest('.js-toggle-favorites-container');
        toggleElement.classList.remove('js-favorite-removed-state')
        toggleElement.classList.add('js-favorite-added-state');
        if (ACC.productFavorites.context == 'flp') {
            toggleElement.closest('.product-variant').classList.remove('product-variant-disabled');
        }
    },
    validateAddToCartButtonClickOnFavoriteList: function (event) {
        var form = $(event.target).closest(".js-favorite-list-add-to-cart-form");
        var qty = $(form).children(".js-favorite-list-qty");
        var noQty = $(form).children(".js-favorite-list-no-quantity");
        if (!$.isNumeric(qty.val()) || qty.val() <= 0) {
            noQty.removeClass('hide');
            return false;
        }
        noQty.addClass('hide');
        return true;
    },
    showPricesOnQuantityChangeFromFavoriteList: function (event) {
        var form = $(event.target).closest(".js-favorite-list-add-to-cart-form");
        var qty = $(form).children(".js-favorite-list-qty");
        var qtyUnit = $(form).find(".js-favorite-list-qty-unit").children(":selected");
        var variantProduct = $(form).children(".js-favorite-list-product-code");
        var totalPrice = $(form).children(".js-favorite-list-total-item-price");
        totalPrice.html($("<img class='spinner-img' src='" + ACC.config.resource.spinner + "'/>"));

        $.ajax({
            async: true,
            type: "POST",
            dataType: 'json',
            contentType: 'application/json',
            url: ACC.pdp.pricingPdpPricesUrl,
            data: JSON.stringify({
                variantProductCode: variantProduct.val(),
                quantity: qty.val(),
                quantityUnitCode: qtyUnit.val(),
            }),
            error: function (data, status) {
                console.log(data);
                totalPrice.addClass('hide');
            },
            success: function (data, status) {
                if (ACC.productFavorites.priceRequestRetryTimeoutMap.get(variantProduct.val())) {
                    clearTimeout(ACC.productFavorites.priceRequestRetryTimeoutMap.get(variantProduct.val()));
                }
                if (data && data.status && data.status === "READY") {
                    if (data.resultObject.variantPriceTotal && data.resultObject.variantPriceTotal.formattedValue) {
                        var price = data.resultObject.variantPriceTotal.formattedValue
                        + "<span>"
                        + data.resultObject.variantPrice.formattedValue
                        + "</span>";
                        totalPrice.html(price);
                        totalPrice.removeClass('hide');
                    } else {
                        totalPrice.addClass('hide');
                    }
                } else {
                    ACC.productFavorites.priceRequestRetryTimeoutMap.set(variantProduct.val(),
                        setTimeout(ACC.productFavorites.showPricesOnQuantityChangeFromFavoriteList, 500, event));
                }
            }
        });

        return true;
    },
    showNoDimensionsMessage: function (event) {
        var toggleElement = event.target.closest('.js-toggle-favorites-container');
        var variantCode = $(toggleElement).data('product-code');

        if (ACC.productFavorites.context == 'pdp' && !variantCode) {
            $('.js-no-dimensions').removeClass('hide');
        }
    },
    handleHeaderNotification: function () {
        this.removeHeaderNotification();
        $('.nav-link .icon-favorite-inactive').before(this.getNotificationTemplate());
        setTimeout(function () {
            ACC.productFavorites.removeHeaderNotification();
        }, 4000);
    },
    getNotificationTemplate: function () {
        return '<div class="add-to-favorites-header-notification">' +
            '<div class="caret"></div>' +
            '<span class="icon-favorite-active"></span>' +
            '<span class="notification-text">' +
            this.getNotificationText() +
            '</span>' +
            '</div>';
    },
    getNotificationText: function () {
        return $('.js-toggle-favorites-container .text-active:first').text();
    },
    removeHeaderNotification: function () {
        $('.nav-link .add-to-favorites-header-notification').remove();
    },
    adjustFavoritePageTemplate: function (toggleElement) {
        var masterElement = toggleElement.closest('.master-entry');
        var variantsNumber = masterElement.querySelectorAll('.product-variant').length;
        if (variantsNumber === 1) {
            masterElement.remove();
            if (!$('.master-entry').length) {
                $('.favourites-list-container').addClass('hidden');
                $('.empty-favourites-list-container').removeClass('hidden');
            }
        } else {
            toggleElement.closest('.product-variant').remove();
            masterElement.querySelector('.variant-count').innerText = variantsNumber - 1;
        }
    },
    productAvailability: {

        updateAvailabilityStatus: function (variant) {
            var variantData = variant.data() || {};
            if (!variantData.visible) {
                ACC.productFavorites.productAvailability.disableVariant($(variant));
            } else if (!variantData.buyable) {
                ACC.productFavorites.productAvailability.HideAddToCart($(variant));
            } else {
                $(variant).css('opacity', 1);
            }
        },
        initAddToCartButton: function () {
            $(".favorite-addtocart-container > .js-add-to-quotecart")
                .removeClass("btn btn-block btn-darkgrey")
                .addClass("favorite-entry-add-quote");
        },

        disableElement: function (element) {
            element.attr('disabled', true)
                .css('opacity', ACC.productFavorites.constants.DISABLED_ELEMENT_OPACITY)
                .css('pointer-events', 'none')
        },

        hideElement: function (element) {
            element.css('display', 'none');
        },

        disableVariant: function (favoriteListVariant) {
            favoriteListVariant.find(':button').each(function () {
                ACC.productFavorites.productAvailability.disableElement($(this))
            })
        },

        HideAddToCart: function (favoriteListVariant) {
            favoriteListVariant.find('#btnAddToCartButton :button').each(function () {
                ACC.productFavorites.productAvailability.hideElement($(this))
            })
        },

        updateFavoriteEntriesAvailabilityStatus: function () {

            var favoriteListVariants = $(".product-variant > .favorite-addtocart-container");
            favoriteListVariants.each(function () {
                ACC.productFavorites.productAvailability.updateAvailabilityStatus($(this))
            })
        },
    }
}

$(document).ready(function () {
    if ($('.js-toggle-favorites-container').length) {
        ACC.productFavorites.productAvailability.initAddToCartButton();
        ACC.productFavorites.bind();
        ACC.productFavorites.productAvailability.updateFavoriteEntriesAvailabilityStatus();
        if (!!$('.favorite-list-page').length) {
            ACC.productFavorites.context = 'flp';
        } else if (!!$('.productDetailsPanel').length) {
            ACC.productFavorites.context = 'pdp';
        } else if (!!$('.js-product-listing-page').length) {
            ACC.productFavorites.context = 'plp';
        }
    }
});
